import {Condition} from '@/model/types';
import {ContractTypes} from '../src/values/dv-93';

export const isExistingAccountsContractType = <TContractType extends ContractTypes>(type: TContractType) =>
  ({
    field: 'I193',
    operator: '=',
    value: type,
  }) as const satisfies Condition;
